class HeaderDrawer extends SideDrawer {
  constructor() {
    super();
    this.moved = false;
    this.header = this.header || document.querySelector('.header-wrapper');
  }

  open(triggeredBy) {
    if (this.header) {
      this.header.classList.add('open-header-drawer');
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom)}px`);
    }
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    document.body.addEventListener('click', this.onBodyClickEvent);
    window.addEventListener('resize', this.onResize);
    super.open(triggeredBy);
  }

  close() {
    super.close();
    if (this.header) {
      this.header.classList.remove('open-header-drawer');
      document.documentElement.style.removeProperty('--header-bottom-position');
    }
    document.body.removeEventListener('click', this.onBodyClickEvent);
    window.removeEventListener('resize', this.onResize);
  }

  onBodyClick(event) {
    if (!this.activeElement.contains(event.target) && !this.contains(event.target)) {
      this.close();
    }
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

if (!customElements.get('menu-details')) {
  customElements.define('menu-details',
    class MenuDetails extends HTMLElement {
      constructor() {
        super();
        this.summary.addEventListener('click', this.onSummaryClick.bind(this));
        this.button.addEventListener('click', this.onButtonClick.bind(this));
        
        this.addEventListener('click', this.onNestedDrawerClick.bind(this));
      }

      get parent() {
        return this.closest('[data-menu-details-parent]');
      }

      get details() {
        return this.querySelector('details');
      }

      get summary() {
        return this.querySelector('summary');
      }

      get button() {
        return this.querySelector('button');
      }

      setMegaMenuOpen() {
        const megaMenu = this.querySelector('mega-menu');
        megaMenu?.setAttribute('open', true);
      }
  
      setMegaMenuClose() {
        const megaMenu = this.querySelector('mega-menu');
        megaMenu?.removeAttribute('open');
      }

      onNestedDrawerClick(event) {
        const clickedSummary = event.target.closest('summary');
        if (!clickedSummary) return;
        
        const parentDetails = clickedSummary.parentElement;
        if (!parentDetails || !parentDetails.classList.contains('js-menu-drawer')) {
          return; 
        }
        
        const allMenuDrawers = document.querySelectorAll('details.js-menu-drawer');
        allMenuDrawers.forEach(drawer => {
          if (drawer !== parentDetails && drawer.open) {
            drawer.open = false;
          }
        });
      }

      onSummaryClick() {
        this.setMegaMenuOpen();
        setTimeout(() => {
          this.parent.classList.add('active');
          this.classList.add('active');
          this.setAttribute('open', true);
          this.details.setAttribute('open', true);
          this.summary.setAttribute('aria-expanded', true);
        }, 100);
      }

      onButtonClick() {
        this.setMegaMenuClose();
        this.parent.classList.remove('active');
        this.classList.remove('active');
        this.removeAttribute('open');
        this.details.removeAttribute('open');
        this.summary.setAttribute('aria-expanded', false);
      }
    }
  )
}